import Text from './Text'

export default function FormError(props: { error: React.ReactNode }) {
  return (
    <Text size={12} color="Red400" display="block">
      {props.error}
    </Text>
  )
}
